import { render, staticRenderFns } from "./studentInfoCertificationRecord_5.vue?vue&type=template&id=ff7b7a9e&scoped=true"
import script from "./studentInfoCertificationRecord_5.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_5.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_5.vue?vue&type=style&index=0&id=ff7b7a9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b7a9e",
  null
  
)

export default component.exports